import { Component, OnInit, Input, Output , EventEmitter} from '@angular/core';
// import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirmationdialog',
  templateUrl: './confirmationdialog.component.html',
  styleUrls: ['./confirmationdialog.component.css']
})
export class ConfirmationdialogComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  answer: boolean;

  @Output() action = new EventEmitter();

  constructor(private activeModal: BsModalRef, public modalService: BsModalService) {

    // console.log("constructor(private activeModal: BsModalRef)")
    // console.log(activeModal)
    // console.log("modalService.config.initialState")
    // console.log(modalService.config.initialState)

   }

  ngOnInit() {

  }

  public cancel() {

    this.answer = false;
    this.action.emit(false);
    this.activeModal.hide();
  }

  public accept() {

    this.answer = true;
    this.action.emit(true); // emmitter not using now. but its an example
    this.activeModal.hide();
  }

  public dismiss() {

    this.answer = false;
    this.action.emit(false);
    this.activeModal.hide();
  }
}
